// extracted by mini-css-extract-plugin
export default {"columns":"style_columns__2mOoH","hiden":"style_hiden__KJhVJ"};